function init() {

    $("#sales-directory-select").on("change", selectLocation);

}

function selectLocation(select) {
    // only change window location if selected value is for new location and also not the "select a location" option
    if (select.target.value.toLowerCase() !== window.location.pathname.toLowerCase() &&
        select.target.options[select.selectedIndex] !== select.target[0]) {
        window.location = select.target.value;
    }
}

export default {
    init
}